export default __webpack_public_path__ + "static/media/sketch.60505e66.png";